import script from "./createHTML.vue?vue&type=script&setup=true&lang=js"
export * from "./createHTML.vue?vue&type=script&setup=true&lang=js"

import "./createHTML.vue?vue&type=style&index=0&id=198669af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198669af"]])

export default __exports__